import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { ValidarComponent } from './components/validar/validar.component';
import { DocenteParComponent } from './components/docente-par/docente-par.component';
import { ParComponent } from './components/par/par.component';
import { EstudianteComponent } from './components/estudiante/estudiante.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { InstructivoComponent } from './components/instructivo/instructivo.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'validar',
    component: ValidarComponent
  },
  { path: 'perfil', loadChildren: () => import('./components/perfil/perfil.module').then(m => m.PerfilModule) },

  {
    path: 'jefe/:uaa',
    component: ParComponent
  },
  {
    path: 'docente/:grupo/:uaa',
    component: DocenteParComponent
  },
  {
    path: 'panel/:grupo',
    component: EstudianteComponent
  },
  {
    path: 'instructivo',
    component: InstructivoComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
